import script from "./PerformanceAppraisalList.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceAppraisalList.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceAppraisalList.vue?vue&type=style&index=0&id=408234d4&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/DBCapacity-VUE/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408234d4"]])

export default __exports__